import React from "react";
export const FilterContext: any = React.createContext([]);
